import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "crosshover"
const CrosshoverIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="m14.45 15.75-5.912 5.913-1.326-1.326 3.65-3.65H2.25v-1.875h8.612l-3.65-3.65 1.326-1.325zM16.788 3.663l-3.65 3.65h8.612v1.875h-8.612l3.65 3.65-1.326 1.325L9.55 8.25l5.913-5.913z" />
        </svg>
      }
    </span>
  )
}
export default CrosshoverIcon
